import { render, staticRenderFns } from "./comparacao-custos.vue?vue&type=template&id=6c07de3a&scoped=true"
import script from "./comparacao-custos.vue?vue&type=script&lang=js"
export * from "./comparacao-custos.vue?vue&type=script&lang=js"
import style0 from "./comparacao-custos.vue?vue&type=style&index=0&id=6c07de3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c07de3a",
  null
  
)

export default component.exports